export default [
  { prop: 'data.title', header: 'Name', style: { width: '100%' } },
  { prop: 'id', header: 'ID' },
]
